export default __webpack_public_path__ + "static/media/icon-ethereum.2aef4373.png";